/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Autodraft from './Autodraft/index'
import CloseAction from './CloseAction/index'
import CustomPlan from './CustomPlan/index'
import Downpayment from './Downpayment/index'
import MaxDiscount from './MaxDiscount/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import OverrideAction from './OverrideAction/index'
import React from 'react'
import ResetAction from './ResetAction/index'
import Steps from './Steps/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={dtSpaceM}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
 size="large"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceS}
 text="Override settings for treatment plan request"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
<Autodraft
  viewPath={`${viewPath}/Autodraft`}
/>
<Downpayment
  viewPath={`${viewPath}/Downpayment`}
/>
</div>
<CustomPlan
  viewPath={`${viewPath}/CustomPlan`}
/>
<MaxDiscount
  viewPath={`${viewPath}/MaxDiscount`}
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<ResetAction
  viewPath={`${viewPath}/ResetAction`}
/>
<OverrideAction
  viewPath={`${viewPath}/OverrideAction`}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}